// src/components/courses/SpecializationHighlight.jsx
import React from 'react';
import styles from './SpecializationHighlight.module.css';
import { FaGraduationCap, FaSyncAlt, FaUserTie, FaLightbulb } from 'react-icons/fa'; // Example icons

const SpecializationHighlight = () => {
  return (
    <section className={styles.specializationSection}>
      <h2 className={styles.sectionHeading}>What Makes Bspark Specialized?</h2>
      <p className="section-subtitle">
        We go beyond traditional training, offering a unique blend of expertise, innovation, and career-focused support.
      </p>

      <div className={styles.specializationGrid}>
        <div className={styles.specializationItem}>
          <div className={styles.iconWrapper}>
            <FaGraduationCap className={styles.icon} />
          </div>
          <h3>Industry-Led Curriculum</h3>
          <p>Courses designed and taught by industry veterans, ensuring relevance and cutting-edge knowledge.</p>
        </div>
        <div className={styles.specializationItem}>
          <div className={styles.iconWrapper}>
            <FaSyncAlt className={styles.icon} />
          </div>
          <h3>Dynamic & Evolving Content</h3>
          <p>Our curriculum is continuously updated to reflect the latest technological advancements and market demands.</p>
        </div>
        <div className={styles.specializationItem}>
          <div className={styles.iconWrapper}>
            <FaUserTie className={styles.icon} />
          </div>
          <h3>Personalized Career Mentorship</h3>
          <p>Beyond training, we offer tailored guidance for job placements, interviews, and long-term career growth.</p>
        </div>
        <div className={styles.specializationItem}>
          <div className={styles.iconWrapper}>
            <FaLightbulb className={styles.icon} />
          </div>
          <h3>Innovation-Driven Learning</h3>
          <p>Focus on problem-solving, critical thinking, and fostering a mindset for continuous innovation.</p>
        </div>
      </div>
    </section>
  );
};

export default SpecializationHighlight;